/* eslint-disable */
import React, { useEffect } from 'react';
import { theme, cssVariables } from 'theme/theme';
import { ThemeProvider } from '@material-ui/core/styles';
import CPRoutes from './routes';
import callUserContext from './client/authserviceV1';
import { UserPortalContext } from './context/appcontext';
import { loadContent, loadAdobeScript } from 'helper/analytics';
import { Announcement } from '@walmart-dataventures/integrated-components';
import { routeToLogin } from 'helper/utils';
import { STUDENT_CODE } from './constants/constant';
import LoadingPage from './components/LoadingPage/LoadingPage';

import './App.css';

function App() {
	useEffect(() => {
		if (window.__DATAVENTURES_PORTAL__ === undefined) {
			defineAdobeAnalytics();
		}
	});

	const { data, loading, error, updateUserPersona, updateItemShareAccepted } = callUserContext();
	const personaAccessCodes = data?.userDetails?.result?.personaAccessCodes;

	if (error) {
		routeToLogin();
		return <></>;
	}

	if (loading) {
		return <div style={{display: 'flex', justifyContent: 'center', alignItems: 'center', textAlign: 'center', minHeight: '100vh', minWidth: '100vw'}} >
			<LoadingPage />
		</div>;
	} 
	
	return (
		<ThemeProvider theme={{ ...theme, ...cssVariables }}>
			<UserPortalContext.Provider
				value={{
					userDetails: data?.userDetails,
					updateUserPersona,
					customerType: data?.customerType,
					isStudent: personaAccessCodes?.includes(STUDENT_CODE),
					isItemShareAccepted: data?.itemShareAccepted,
					updateItemShareAccepted
				}}>
				<Announcement locationBased={true} />
				<CPRoutes />
			</UserPortalContext.Provider>
		</ThemeProvider>
	);
}

function defineAdobeAnalytics() {
	window.__DATAVENTURES_PORTAL__ = {
		dataLayer: { analyticsEvent: [] }
	};

	loadContent(document.getElementsByTagName('head')[0]);
	setTimeout(() => loadAdobeScript(), 3000);
}

export default App;
